import React, { useEffect, useRef } from "react";
import { Routes, Route, useLocation, Outlet, Navigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/fontawesome.css";
import "animate.css";
import "./assets/css/imageRevealHover.css";
import "./assets/css/cursor.css";
import "./assets/css/main.css";
import "./assets/css/home.css";
import Bttpreloader from "./components/Bttpreloader";
import Header from "./components/Header";
import Overlaymenu from "./components/Overlaymenu";
import StickyHeader from "./js/StickyHeader";
import MobileMenu from "./js/MobileMenu";
import CodeForOdometer from "./js/CodeForOdometer";
import LenisProvider from "./js/LenisProvider";
import UkiyoInitializer from "./js/UkiyoInitializer";

import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import WebDevelopment from "./pages/WebDevelopment";
import Smm from "./pages/Smm";
import DigitalMarketing from "./pages/DigitalMarketing";
import VisualBranding from "./pages/VisualBranding";
import Cookies from "js-cookie";

import Faq from "./pages/Faq";
import Terms from "./pages/Terms";
import Blogs from "./pages/Blogs";
import Blog from "./pages/Blog";
import BlogPreview from "./pages/BlogPreview";


//admin imports
import { Login, AdminDashboard } from "./pages/admin/Login";
import Users from "./pages/admin/Users";
import AdminBlogs from "./pages/admin/AdminBlogs";
import CreateBlog from "./pages/admin/CreateBlog";
import EditBlog from "./pages/admin/EditBlog";
import { AlertProvider } from "./pages/admin/context/AlertContext";
import NotFoundPage from "./pages/NotFoundPage";

//Blogger imports
import BloggerLogin from "./pages/blogger/BloggerLogin";
import BlogHome from "./pages/blogger/BlogHome";
import BloggerCreateBlog from "./pages/blogger/CreateBlog";

//BlogHead imports
import BlogHeadLogin from "./pages/blogHead/BlogHeadLogin";
import BlogHeadUsers from "./pages/blogHead/BlogHeadUsers";
import BlogHeadBlogs from "./pages/blogHead/BlogHeadBlogs";
import BlogHeadCreateBlog from "./pages/blogHead/CreateBlog";
import BlogHeadEditBlog from "./pages/blogHead/EditBlog";
import CreateBlogger from "./pages/blogHead/CreateBlogger";

const App = () => {
  const API_HOST = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const isFirstRun = useRef(true);
  let visitCount = parseInt(Cookies.get("visitCount") || "0", 10);

  // Construct full canonical URL, stripping trailing slash to avoid duplicates
  let canonicalUrl = `https://omsoftwares.in${location.pathname.replace(/\/$/, '') || '/'}`;

  useEffect(() => {
    const pathss = {
      home: ".navlihome",
      about: ".navliabout",
      blogs: ".navliblogs",
      services: ".navliServices",
      contact: ".navliContact",
    };
    Object.values(pathss).forEach((element) => {
      document.querySelectorAll(element).forEach((element1) => {
        element1.style.color = "#ffffff";
      });
    });
    let presentClass = pathss[location.pathname.split("/")[1]];
    if (location.pathname === "/" || location.pathname === "/home") {
      presentClass = pathss["home"];
      document.title =
        "Om Softwares - Digital Marketing & Web Development Agency";
    }
    document.querySelectorAll(presentClass).forEach((element) => {
      element.style.color = "#c4ef17";
    });
    // when going to a new route it should open from initially means scrollheight:0
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    StickyHeader();

    if (isFirstRun.current) {
      isFirstRun.current = false;
      Cookies.set("visitCount", visitCount + 1, { expires: 365 });
    }

    (function () {
      try {
        const viewKey = "viewCounted_" + location.href;
        if (sessionStorage.getItem(viewKey)) {
          return; // Do not update view count on refresh
        }

        // Get the referrer value from the browser.
        let referrer = document.referrer;
        const currentHost = window.location.hostname;

        if (referrer) {
          const refUrl = new URL(referrer);

          // If the referrer's hostname matches the current host, it's a self-referral.
          if (refUrl.hostname === currentHost) {
            return; // Do nothing for self-referrals.
          }

          // If the referrer is from Facebook, remove the fbclid parameter to group all FB referrals.
          if (refUrl.hostname.includes("facebook.com")) {
            refUrl.searchParams.delete("fbclid");
            referrer = refUrl.toString();
          }
        } else {
          // If there's no referrer (e.g., the user typed the URL directly), mark it as "nonreferral".
          referrer = "nonreferral";
        }

        // Prepare the data payload
        const data = { referrer: referrer };

        // Send the update request to your API.
        fetch(`${API_HOST}views/update`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }).catch(() => {
          // Silently ignore any fetch errors
        });

        // Mark this page view as counted in sessionStorage.
        sessionStorage.setItem(viewKey, "true");
      } catch (err) {
        // Silently ignore any errors encountered in the process.
      }
    })();
  }, [visitCount]);

  const component = visitCount % 2 === 0 ? "VidHero" : "Hero";

  const n =
    (location.pathname === "/" || location.pathname === "/home") &&
    component === "VidHero"
      ? {
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 6,
          borderBottom: 0,
        }
      : {
          position: "relative",
          borderBottom: "1px solid #242424",
          top: "",
          left: "",
          width: "",
        };

  return (
    <>
      <Bttpreloader />
      {/* <OverlayHeader /> */}
      <LenisProvider />
      <UkiyoInitializer />
      <Overlaymenu />
      <CodeForOdometer />

      <MobileMenu />
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      <div className="body_wrap">
        <Header style={n} />

        <Routes>
          <Route
            index
            element={<Home component={component} visitCount={visitCount} />}
          />
          {/* Redirect duplicate routes to canonical URLs */}
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/service" element={<Navigate to="/services" replace />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/smm" element={<Navigate to="/social-media-management" replace />} />
          <Route path="/social-media-management" element={<Smm />} />
          <Route path="/digital-marketing" element={<DigitalMarketing />} />
          <Route path="/web-development" element={<WebDevelopment />} />
          <Route path="/visual-branding" element={<VisualBranding />} />
          <Route path="/faq" element={<Navigate to="/faqs" replace />} />
          <Route path="/faqs" element={<Faq />} />
          <Route path="/term" element={<Navigate to="/terms" replace />} />
          <Route path="/terms" element={<Terms />} />

          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blog" element={<Navigate to="/blogs" replace />} />
          <Route path="/blog/:urlHeading" element={<Blog />} />
          <Route path="/preview/:urlHeading" element={<BlogPreview />} />


          <Route
            path="admin"
            element={
              <AlertProvider>
                <Helmet>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <Outlet />
              </AlertProvider>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="admin-dashboard" element={<AdminDashboard />} />
            <Route path="login" element={<Login />} />
            <Route path="blogs" element={<AdminBlogs />} />
            <Route path="blogs/create" element={<CreateBlog />} />
            <Route path="blogs/edit/:id" element={<EditBlog />} />
            <Route path="users" element={<Users />} />
          </Route>

          <Route
            path="bloghead"
            element={
              <AlertProvider>
                <Helmet>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <Outlet />
              </AlertProvider>
            }
          >
            <Route path="login" element={<BlogHeadLogin />} />
            <Route path="blogs" element={<BlogHeadBlogs />} />
            <Route path="blogs/create" element={<BlogHeadCreateBlog />} />
            <Route path="blogs/edit/:id" element={<BlogHeadEditBlog />} />
            <Route index element={<BlogHeadBlogs />} />
            <Route path="users" element={<BlogHeadUsers />} />
            <Route path="create-blogger" element={<CreateBlogger />} />
          </Route>

          <Route
            path="blogger"
            element={
              <AlertProvider>
                <Helmet>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <Outlet />
              </AlertProvider>
            }
          >
            <Route path="login" element={<BloggerLogin />} />
            <Route index element={<BlogHome />} />
            <Route path="blogs" element={<BlogHome />} />
            <Route path="blogs/create" element={<BloggerCreateBlog />} />
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
      </div>
    </>
  );
};

export default App;
